import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {stickyHeaderHeight} from "../list/constants/sticky_header_height";

export type AiAdvisorSpotlightSource = "searchPill" | "sidebarHandle";

export interface IOfferListingStore {
    isListingNavigationSticky: boolean;
    stickyHeaderVisibility: 0 | 1;
    stickyHeaderCurrentHeight: number;
    isAiAdvisorSidebarAvailable: boolean;
    aiAdvisorSpotlightSource: AiAdvisorSpotlightSource | null;
}

export const offerListingSliceInitialState: IOfferListingStore = {
    isListingNavigationSticky: false,
    stickyHeaderVisibility: 0,
    stickyHeaderCurrentHeight: stickyHeaderHeight,
    isAiAdvisorSidebarAvailable: false,
    aiAdvisorSpotlightSource: null
};

export const offerListingSlice = createSlice({
    name: "offerListing",
    initialState: offerListingSliceInitialState,
    reducers: {
        setOfferListingNavigationSticky: (state, action: PayloadAction<boolean>) => {
            state.isListingNavigationSticky = action.payload;
        },
        setStickyHeaderVisibility: (state, action: PayloadAction<0 | 1>) => {
            state.stickyHeaderVisibility = action.payload;
        },
        setStickyHeaderCurrentHeight: (state, action: PayloadAction<number>) => {
            state.stickyHeaderCurrentHeight = action.payload;
        },
        setAiAdvisorSidebarAvailable: (state, action: PayloadAction<boolean>) => {
            state.isAiAdvisorSidebarAvailable = action.payload;
        },
        setAiAdvisorSpotlightSource: (state, action: PayloadAction<AiAdvisorSpotlightSource | null>) => {
            state.aiAdvisorSpotlightSource = action.payload;
        }
    }
});

export const {
    setOfferListingNavigationSticky,
    setStickyHeaderVisibility,
    setStickyHeaderCurrentHeight,
    setAiAdvisorSidebarAvailable,
    setAiAdvisorSpotlightSource
} = offerListingSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {stickyHeaderHeight} from "../list/constants/sticky_header_height";

export type AiAdvisorSpotlightSource = "searchPill" | "sidebarHandle";

export interface IOfferListingStore {
    isListingNavigationSticky: boolean;
    stickyHeaderVisibility: 0 | 1;
    stickyHeaderCurrentHeight: number;
    isAiAdvisorSidebarAvailable: boolean;
    aiAdvisorSpotlightSource: AiAdvisorSpotlightSource | null;
}

export const offerListingSliceInitialState: IOfferListingStore = {
    isListingNavigationSticky: false,
    stickyHeaderVisibility: 0,
    stickyHeaderCurrentHeight: stickyHeaderHeight,
    isAiAdvisorSidebarAvailable: false,
    aiAdvisorSpotlightSource: null
};

export const offerListingSlice = createSlice({
    name: "offerListing",
    initialState: offerListingSliceInitialState,
    reducers: {
        setOfferListingNavigationSticky: (state, action: PayloadAction<boolean>) => {
            state.isListingNavigationSticky = action.payload;
        },
        setStickyHeaderVisibility: (state, action: PayloadAction<0 | 1>) => {
            state.stickyHeaderVisibility = action.payload;
        },
        setStickyHeaderCurrentHeight: (state, action: PayloadAction<number>) => {
            state.stickyHeaderCurrentHeight = action.payload;
        },
        setAiAdvisorSidebarAvailable: (state, action: PayloadAction<boolean>) => {
            state.isAiAdvisorSidebarAvailable = action.payload;
        },
        setAiAdvisorSpotlightSource: (state, action: PayloadAction<AiAdvisorSpotlightSource | null>) => {
            state.aiAdvisorSpotlightSource = action.payload;
        }
    }
});

export const {
    setOfferListingNavigationSticky,
    setStickyHeaderVisibility,
    setStickyHeaderCurrentHeight,
    setAiAdvisorSidebarAvailable,
    setAiAdvisorSpotlightSource
} = offerListingSlice.actions;
